import axios from './interceptor';

const QRY_URL = `${process.env.REACT_APP_BASE_URL}/image`;


export async function getImages(schema, id) {
    const ADDUSER_URL = `${QRY_URL}/get/${schema}/${id}`;
    const result = await axios.get(ADDUSER_URL);
    return result.data;

};

export async function imageUpload(schema, id, payload) {
    const ADDUSER_URL = `${QRY_URL}/upload/${schema}/${id}`;
    const result = await axios.post(ADDUSER_URL, payload);
    return result.data;
};

export async function imageDelete(schema, id, payload) {
    const ADDUSER_URL = `${QRY_URL}/delete/${schema}/${id}`;
    const result = await axios.delete(ADDUSER_URL, payload);
    return result.data;
};

export async function reorderImages(schema, id, payload) {
    const REORDER_URL = `${QRY_URL}/reorder/${schema}/${id}`;
    const result = await axios.put(REORDER_URL, payload);
    return result.data;
};

// Returns { dataUrl } for one of our blob-hosted images (used to embed photos in PDFs)
export async function proxyImage(url) {
    const PROXY_URL = `${QRY_URL}/proxy`;
    const result = await axios.get(PROXY_URL, { params: { url } });
    return result.data;
};
